module.exports = __webpack_public_path__ + "static/media/BBCReithSans_W_Bd.f1766553.woff";